import {variables} from "$lib/helpers/variables.js";

export const load = ({ fetch }) => {
    const fetchPosts = async () => {
        const res = await fetch(variables.publicSiteUrl + 'api/cookie-policy',{
            method: 'GET',
            credentials: 'same-origin',
            redirect: 'follow',
            agent: null,
            headers: {
                "Content-Type": "text/plain",
                'Authorization': 'Basic ' + btoa(`${variables.httpUsername}:${variables.httpPassword}`),
            },
            timeout: 5000
        });
        const data = await res.json();
        return data;
    };

    let content = fetchPosts();

    return {
        content
    };
};

// export const csr = false;
// export const prerender = true;